var Glyphicon = require("components/utility/icons/Glyphicon");

require("data/widgets/widget_title.scss");

class WidgetTitle extends React.Component {
  constructor(props) {
    super();
    autobind(this);
  }

  renderTitle() {
    return (
      <div className="title">
        {this.props.config.title}
      </div>
    )
  }

  renderIcon() {
    var icon = this.props.config.icon ? this.props.config.icon : 'writing-white'
    return (
      <div className="iconContainer hideOnPrint">
        <div className="iconBackground">
          <img className='icon' src={require(`widget-icons/${icon}.png`)} />
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="widgetTitle">
        {this.renderIcon()}
        {this.renderTitle()}
      </div>
    )
  }
};

// WidgetTitle.WrappedComponent.propTypes = PageStrictPropTypes({
// });

module.exports = WidgetTitle;


// WEBPACK FOOTER //
// ./modules/components/data/widgets/helpers/WidgetTitle.js